import { render, staticRenderFns } from "./WorkerButtonsWidget.vue?vue&type=template&id=7e064c0a&scoped=true&"
import script from "./WorkerButtonsWidget.vue?vue&type=script&lang=ts&"
export * from "./WorkerButtonsWidget.vue?vue&type=script&lang=ts&"
import style0 from "./WorkerButtonsWidget.vue?vue&type=style&index=0&id=7e064c0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e064c0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VSlideGroup,VSlideItem})
